import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import StorageHandler from '@/helpers/StorageHandler';
import router from '@/router';
import i18n from '@/i18n';
import "core-js";

export default {
  namespaced: true,
  state: () => ({
    active: 'en',
    default: 'en',
    icon: '/static/img/language/icons/en.png',
  }),
  mutations: {
    setLanguage(state, value) {
      state.active = value;
    },
  },
  actions: {
    async init({ dispatch }) {
      // INIT LANGUAGE
      const value = StorageHandler.get('lang') || 'en';
      dispatch('set', value);
      return Promise.resolve();
    },
    // setLangDefault({ dispatch }, value) {
    //   // StorageHandler.save('lang', context.iso);
    //   dispatch('set', value);
    // },
    async set({ commit, dispatch, state, rootState, rootGetters }, value) {
      // 1) Muss eine von der App unterstuetzte Sprache sein (Uebersetzung in i18n vorhanden)
      if (!i18n[value]) {
        dispatch(
          'notification/new',
          {
            title: 'Not supported Lang',
            message: value,
          },
          {
            root: true,
          }
        );
        // Unbekannte Sprache -> Fallback auf Default (Englisch), auch im Storage
        commit('setLanguage', state.default);
        await StorageHandler.save('lang', state.default);
        return Promise.resolve();
      }

      // 2) Muss im Customizer fuer dieses Building freigegeben sein.
      //    Nur pruefen, wenn das Building bereits bekannt ist (Customizer geladen),
      //    damit der fruehe init() aus dem Storage nicht faelschlich zurueckfaellt.
      const buildingKnown = !!(rootState && rootState.buildingId);
      if (buildingKnown) {
        const langCustomizer = rootGetters['customizer/getLanguages'] || {};
        const entry = langCustomizer[value];
        if (!entry || !entry.show) {
          dispatch(
            'notification/new',
            {
              title: 'Lang not enabled for building',
              message: value,
            },
            {
              root: true,
            }
          );
          // Gesperrte Sprache -> aktiv auf Default (Englisch), damit Text UND Fahne konsistent sind.
          // Storage bewusst NICHT ueberschreiben, damit der Wunschwert erhalten bleibt,
          // falls das Building die Sprache spaeter doch freigibt.
          commit('setLanguage', state.default);
          return Promise.resolve();
        }
      }

      commit('setLanguage', value);
      await StorageHandler.save('lang', value);
      return Promise.resolve();
    },
    async select({ dispatch }, context) {
      await dispatch('set', context.iso);
      return Promise.resolve();
    },
  },
  getters: {
    getLang(state) {
      return state.active;
    },
    getLangItems(_, _get, _root, getters) {
      console.log(getters['navigation/getLangSubMenu']);
      if (!getters['navigation/getLangSubMenu']) return [];
      return getters['navigation/getLangSubMenu'].items;
    },
    getActiveLang(state, getters) {
      const items = getters.getLangItems || [];
      // Aktive Sprache im Menue suchen; nicht verfuegbar -> Fallback auf Default (Englisch)
      const active = items.find(function(el) { if (el.iso === state.active) return el; });
      if (active) return active;
      const fallback = items.find(function(el) { if (el.iso === state.default) return el; });
      return fallback || null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/lang.js